import { fork } from 'typed-redux-saga';
import watchApiCartSaga from './watchApiCartSaga';

function* cartApiSaga(): Generator {
  yield* fork(watchApiCartSaga);
}

export default cartApiSaga;
